/*
 * Public API Surface of angular-editor
 */

export * from './lib/angular-editor.service';
export * from './lib/angular-editor.component';
export * from './lib/angular-editor-toolbar.component';
export * from './lib/angular-editor.module';
export { AngularEditorConfig, CustomClass } from './lib/config';
